<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑员工' : '新增员工'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <div class="department-box">
            <div class="t-a-r" style="width: 120px">
              <span class="m-r-4 c-red">*</span>
              <span class="m-r-5 c-black">所属组织</span>
            </div>
            <b-organize-staff :data.sync="selfData.department_data" width="1288px" />
          </div>
          <e-form ref="refForm" :column="formColumn" :rules="formRules" :data.sync="selfData" />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        id: '', // 员工id(编辑时不能修改) yuan_gong_user_id
        yuan_gong_user_name: '', // 姓名
        yuan_gong_user_code: '', // 工号(自动生成后，不能修改)
        gender: '', // 性别
        min_zu_name: '', // 民族
        xue_li: '', // 学历
        hu_kou_place: '', // 籍贯
        hu_kou_address: '', // 户籍地址
        marry_type: '', // 婚姻状况
        department_ids: [], // 所属组织id[1,2,3,4]
        department_data: {},
        job_leader_id: '', // 上级负责人id
        job_station_id: '', // 所属职位id
        yuan_gong_user_phone: '', // 手机号码
        job_location_id: '', // 工作地点id
        job_area_ids: [], // 工作城市id[1,2,3,4]
        job_area_str: '', // 工作城市
        yuan_gong_user_staff_type: '', // 员工类型['全职','兼职','实习','临时工']
        yuan_gong_user_staff_status: '', // 员工状态['试用','正式']
        yuan_gong_user_job_in_date: '', // 入职日期(yyyy-mm-dd)
        yuan_gong_user_email: '', // 联系邮箱
        status: true // 状态
      },
      formColumn: [
        {
          type: 'text',
          title: '姓名',
          field: 'yuan_gong_user_name',
          width: '50%',
          required: true
        },
        {
          type: 'text',
          title: '工号',
          field: 'yuan_gong_user_code',
          width: '50%',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'select',
          title: '性别',
          field: 'yuan_gong_user_gender',
          width: '50%',
          options: [
            {
              key: '男',
              val: '男'
            },
            {
              key: '女',
              val: '女'
            }
          ]
        },
        {
          type: 'text',
          title: '民族',
          field: 'yuan_gong_user_min_zu_name',
          width: '50%'
        },
        {
          type: 'select',
          title: '学历',
          field: 'yuan_gong_user_xue_li',
          width: '50%',
          options: [
            {
              key: '小学',
              val: '小学'
            },
            {
              key: '初中',
              val: '初中'
            },
            {
              key: '高中',
              val: '高中'
            },
            {
              key: '中专',
              val: '中专'
            },
            {
              key: '大专',
              val: '大专'
            },
            {
              key: '本科',
              val: '本科'
            },
            {
              key: '硕士',
              val: '硕士'
            },
            {
              key: '博士',
              val: '博士'
            }
          ]
        },
        {
          type: 'text',
          title: '籍贯',
          field: 'yuan_gong_user_hu_kou_place',
          width: '50%'
        },
        {
          type: 'text',
          title: '户籍地址',
          field: 'yuan_gong_user_hu_kou_address',
          width: '50%'
        },
        {
          type: 'select',
          title: '婚姻状况',
          field: 'yuan_gong_user_marry_type',
          width: '50%',
          options: [
            {
              key: '未婚',
              val: '未婚'
            },
            {
              key: '已婚',
              val: '已婚'
            }
          ]
        },
        {
          type: 'select',
          title: '上级负责人',
          field: 'job_leader_id',
          width: '50%',
          options: []
        },
        {
          type: 'select',
          title: '所属职位',
          field: 'job_station_id',
          width: '50%',
          options: []
        },
        {
          type: 'number',
          title: '手机号码',
          field: 'yuan_gong_user_phone',
          width: '50%'
        },
        {
          type: 'select',
          title: '工作地点',
          field: 'job_location_id',
          width: '50%',
          options: []
        },
        {
          type: 'text',
          title: '工作城市',
          field: 'job_area_str',
          width: '50%',
          placeholder: '自动填充',
          disabled: true
        },
        {
          type: 'select',
          title: '员工类型',
          field: 'yuan_gong_user_staff_type',
          width: '50%',
          options: [
            {
              key: '全职',
              val: '全职'
            },
            {
              key: '兼职',
              val: '兼职'
            },
            {
              key: '实习',
              val: '实习'
            },
            {
              key: '临时工',
              val: '临时工'
            }
          ]
        },
        {
          type: 'select',
          title: '员工状态',
          field: 'yuan_gong_user_staff_status',
          width: '50%',
          options: [
            {
              key: '试用',
              val: '试用'
            },
            {
              key: '正式',
              val: '正式'
            }
          ]
        },
        {
          type: 'date',
          title: '入职日期',
          field: 'yuan_gong_user_job_in_date',
          width: '50%'
        },
        {
          type: 'text',
          title: '联系邮箱',
          field: 'yuan_gong_user_email',
          width: '50%'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status',
          width: '50%'
        }
      ],
      formRules: {
        yuan_gong_user_name: [{ required: true, message: '请输入姓名' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    'selfData.job_location_id': {
      handler(val) {
        this.formColumn.forEach((itemSt) => {
          if (itemSt.field === 'job_location_id') {
            itemSt.options.forEach((itemNd) => {
              if (itemNd.val === val) {
                this.selfData.job_area_ids = this.$util.deepCopy(itemNd.address_area_ids)
                this.selfData.job_area_str = itemNd.address_area_str
              }
            })
          }
        })
      },
      deep: true
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.loaded = true
    }
    this.getYuanGongListData()
    this.getGangweiListData()
    this.getWorkListData()
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/yuanGong2/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 获取员工列表数据
    getYuanGongListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/yuanGong2/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.yuan_gong_user_name,
                val: item.id,
                disabled: item.status === false
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'job_leader_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取岗位列表数据
    getGangweiListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gangwei2/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.name,
                val: item.id,
                disabled: item.status === false
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'job_station_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 获取工作地点列表数据
    getWorkListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/work2/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.work_name,
                val: item.id,
                disabled: item.status === false,
                address_area_ids: item.address_area_ids,
                address_area_str: item.address_area_str.join('/')
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'job_location_id') item.options = result
            })
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/yuanGong2/saveOrUpdate',
            data: {
              form_data: {
                ...this.selfData,
                department_ids: this.selfData.department_data.department_list.map((item) => item.id)
              }
            }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .department-box {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 750px;
    margin-bottom: 10px;
  }
}
</style>
